<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <PrizesForm @submit-requested="submitRequested"></PrizesForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import PrizesForm from './PrizesForm.vue'

  export default {
  components: { PrizesForm },
  methods: {
    ...mapActions('prizes', ['postPrize']),
    submitRequested (input) {
      this.postPrize(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 